<!-- 异常持续/关闭时间Column -->
<template>
    <div>
        <div v-if='row.status' class='color-green '>
            {{ $timetransition(row.closeTime) }}
        </div>
        <div v-else class='color-red'>
            {{ timeInterval(row.happenTime) }}
        </div>
    </div>
</template>

<script>
import { timeInterval } from '@/utils/time'

export default {
    props: ['row'],
    data() {
        return {

        }
    },
    computed: {
        timeInterval: () => timeInterval,
    },
}
</script>
